import { render } from "./Podium.vue?vue&type=template&id=70ddb0c7&scoped=true"
import script from "./Podium.vue?vue&type=script&lang=js"
export * from "./Podium.vue?vue&type=script&lang=js"

import "./Podium.vue?vue&type=style&index=0&id=70ddb0c7&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-70ddb0c7"

export default script